import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { CreatedContractInterface, ProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface CreateContractWithProductsUseCaseParams {
    products?: ProductInterface[];
    captcha: string;
}

@Injectable()
export class CreateContractWithProductsUseCase
    implements UseCaseWithParam<CreateContractWithProductsUseCaseParams, Observable<Transaction<CreatedContractInterface>>>
{
    constructor(private contractProvider: ContractProvider) {}

    bind(params: CreateContractWithProductsUseCaseParams): Observable<Transaction<CreatedContractInterface>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.contractProvider.createWithProducts(contract, params.products || [], params.captcha),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
